type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  tone?: "light" | "dark";
};

export default function SectionHeading({ eyebrow, title, desc, tone = "light" }: SectionHeadingProps) {
  const isDark = tone === "dark";
  return (
    <div className="max-w-3xl">
      <span
        className={`inline-flex items-center gap-2 rounded-full px-3 py-1 font-label text-xs font-medium tracking-[0.2em] ${
          isDark ? "bg-background-50/10 text-primary-300" : "bg-primary-100 text-primary-800"
        }`}
      >
        <i className="ri-star-smile-line"></i>
        {eyebrow}
      </span>
      <h2
        className={`mt-4 font-heading text-2xl font-bold leading-snug md:text-4xl ${
          isDark ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-3 text-sm leading-relaxed md:text-base ${
            isDark ? "text-background-200" : "text-foreground-600"
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}